import { ReqInfoMocked } from './req-info.mocked';
import { ChangeLog } from '../../models/change-log.model';

export function getSyncChanges(reqInfo: ReqInfoMocked, urlParams: Array<string>): ChangeLog[] {
  return;
}
